module.exports = __webpack_public_path__ + "img/img4.353bd5f1.png";